// import Sticky from 'sticky-js';

const init = () => {
  // const stickyRESidebar = new Sticky('.sidebar--register-event');
  // const stickyVSidebar = new Sticky('.sidebar--volunteer');
  // const stickyFilters = new Sticky('#js-event-filters');
};

export default init
